import { GraphDocumentContext } from "@features/builder/GraphDocumentProvider/context"
import { useContext } from "react"

export const useGraphDocument = () => useContext(GraphDocumentContext)
